/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AllShipmentsSlice } from "./AllShipmentsSlice";
import {
  AllShipmentsSliceFromJSON,
  AllShipmentsSliceFromJSONTyped,
  AllShipmentsSliceToJSON,
  AllShipmentsSliceToJSONTyped,
} from "./AllShipmentsSlice";

/**
 *
 * @export
 * @interface AllShipmentsSplit
 */
export interface AllShipmentsSplit {
  /**
   *
   * @type {Array<AllShipmentsSlice>}
   * @memberof AllShipmentsSplit
   */
  slices: Array<AllShipmentsSlice>;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsSplit
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsSplit
   */
  total: number;
}

/**
 * Check if a given object implements the AllShipmentsSplit interface.
 */
export function instanceOfAllShipmentsSplit(
  value: object,
): value is AllShipmentsSplit {
  if (!("slices" in value) || value["slices"] === undefined) return false;
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("total" in value) || value["total"] === undefined) return false;
  return true;
}

export function AllShipmentsSplitFromJSON(json: any): AllShipmentsSplit {
  return AllShipmentsSplitFromJSONTyped(json, false);
}

export function AllShipmentsSplitFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsSplit {
  if (json == null) {
    return json;
  }
  return {
    slices: (json["slices"] as Array<any>).map(AllShipmentsSliceFromJSON),
    count: json["count"],
    total: json["total"],
  };
}

export function AllShipmentsSplitToJSON(json: any): AllShipmentsSplit {
  return AllShipmentsSplitToJSONTyped(json, false);
}

export function AllShipmentsSplitToJSONTyped(
  value?: AllShipmentsSplit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    slices: (value["slices"] as Array<any>).map(AllShipmentsSliceToJSON),
    count: value["count"],
    total: value["total"],
  };
}
